<template>
    <link
        v-if="cssFile !== null"
        rel="stylesheet"
        :href="cssFile"
    />
</template>

<script>
export default {
    name: 'ThemeCheckout',
    data() {
        return {
            active: false,
            ie: {
                'ags': '/assets/css/ags.css',
                'bsp': '/assets/css/bsp.css',
                'ebr': '/assets/css/ebr.css',
                'fad': '/assets/css/fad.css',
                'fmu': '/assets/css/fmu.css',
                'fpb': '/assets/css/fpb.css',
                'ibmr': '/assets/css/ibmr.css',
                'mca': '/assets/css/mca.css',
                'sjt': '/assets/css/sjt.css',
                'uam': '/assets/css/uam.css',
                'ubh': '/assets/css/ubh.css',
                'ucb': '/assets/css/ucb.css',
                'ufg': '/assets/css/ufg.css',
                'una': '/assets/css/una.css',
                'unf': '/assets/css/unf.css',
                'unp': '/assets/css/unp.css',
                'unr': '/assets/css/unr.css',
                'uns': '/assets/css/uns.css',
                'usc': '/assets/css/usc.css'
            }
        }
    },
    computed: {
        cssFile() {
            if (!this.$route.meta?.checkout) {
                return null
            }

            if (
                'css' in this.$route.query &&
                typeof this.$route.query.css === 'string' &&
                Object.keys(this.ie).includes(this.$route.query.css)
            ) {
                this.$store.commit('setcssCheckoutIE', this.$route.query.css)
            }

            if (
                this.$store.state.cssCheckoutIE !== null &&
                Object.keys(this.ie).includes(this.$store.state.cssCheckoutIE)
            ) {
                return this.ie[this.$store.state.cssCheckoutIE]
            }

            if (Object.keys(this.ie).includes(this.$store.state.ie.sigla)) {
                this.$store.commit(
                    'setcssCheckoutIE',
                    this.$store.state.ie.sigla
                )
                
                return this.ie[this.$store.state.ie.sigla]
            }

            return null
        }
    }
}
</script>